import React, {useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import {AdminHeader} from "./AdminHeader";
import {AdminSidebar} from "./AdminSidebar";
import {Outlet} from "react-router";
import {CookieUtility} from "../common/CookieUtility";

export interface GlobalNavigator {
    navigateTo: Function;
    goBack: Function;
    replace: Function;
}

export interface GlobalContextType {
    navigator: GlobalNavigator;
}

export let GlobalContext = React.createContext<GlobalContextType>({
    navigator: {
        navigateTo: () => null,
        goBack: () => null,
        replace: () => null
    }
});

interface AdminFrameProps {
    children?: React.ReactNode;
}

export let AdminFrame = function (props: AdminFrameProps) {
    let navigate = useNavigate();

    // Anonymous-user auth gate: any admin-frame route (including the `path: '*'` not-found catch-all and other pages that make no authenticated API call) must bounce an unauthenticated visitor to /login rather than leak the admin chrome. The only other anonymous -> /login bounce is 401-driven in ApiUtility, which never fires for a page that issues no API request. "permissionNames" is the auth cookie name, matching AuthUtility and LoginPage.
    let isAuthenticated = Boolean(CookieUtility.load("permissionNames"));

    useEffect(function () {
        if (!isAuthenticated) {
            navigate("/login");
        }
    }, [isAuthenticated, navigate]);

    let context = {
        navigator: {
            navigateTo: function (url: string) {
                navigate(url);
            },
            goBack: function () {
                navigate(-1);
            },
            replace: function (url: string) {
                navigate(url, {replace: true})
            }
        }
    };

    if (!isAuthenticated) {
        return null;
    }

    return (
        <GlobalContext.Provider value={context}>
            <div className="admin-frame">
                <div className="admin-frame-content">
                    <AdminSidebar/>
                    <div className="admin-frame-main">
                        <div className="admin-frame-main-content">
                            <AdminHeader/>
                            <div className="admin-page-content">
                                <Outlet context={context}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </GlobalContext.Provider>
    );
};

